"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JsonView", {
  enumerable: true,
  get: function get() {
    return _jsonView.JsonView;
  }
});
Object.defineProperty(exports, "MhForm", {
  enumerable: true,
  get: function get() {
    return _form.MhForm;
  }
});
Object.defineProperty(exports, "MhFormItem", {
  enumerable: true,
  get: function get() {
    return _form.MhFormItem;
  }
});
exports.Locale = exports.Utils = exports.VueJsonView = void 0;

var _json2view = require("./json2view");

var _action = require("./json2view/action");

var _jsonView = require("./jsonView");

var _form = require("./form");

var _utils = require("./utils");

var _ele2Node = require("./json2view/ele2Node");

var _transText = require("./json2view/transText");

var _locale = require("./locale");

var _formula = require("./json2view/formula");

var VueJsonView = {
  install: function install(vue) {
    vue.use(_form.MhForm);
  },
  json2View: _json2view.json2View,
  ele2VNode: _json2view.ele2VNode,
  addTransChain: _json2view.addTransChain,
  setActionFunc: _action.setActionFunc,
  addFormula: _formula.addFormula
};
exports.VueJsonView = VueJsonView;
var Utils = {
  getDataByName: _utils.getDataByName,
  setDataByObj: _utils.setDataByObj,
  transAllStr2Text: _ele2Node.transAllStr2Text,
  transText: _transText.transText
};
exports.Utils = Utils;
var Locale = {
  setLang: _locale.setLang,
  getLang: _locale.getLang,
  setLib: _locale.setLib,
  tl: _locale.tl
};
exports.Locale = Locale;